import React, { useState } from 'react';
import { Button, Row, Col, Form, Popconfirm } from 'antd';
import Input from '../../ui/Input'
import TextArea from '../../ui/TextArea'
import { CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';
import Collapse, {Panel} from '../../ui/Collapse';
import './index.css'

const FormItem = Form.Item

interface propsTypes {
    detailData: object | any,
    currentForm: any,
    setValidateCount: void | any,
    validateCount: number
}
interface dataType {
    name: string
}
const GeneralEnvironmentalProgramEdit = (props: propsTypes) => {
    const [refreshCount, setRefreshCount] = useState(0)
    const data = props?.detailData?.environmentalimpact?.general?.envprograms || []
    const [detailData, setDetailData] = useState(data)
    const [isValidate, setIsValidate] = useState(false)


    //only need to change data which can controlling Panel rendering
    const deleteItem = (index: number) => {
        
        const validData = detailData.filter((item: { name: string; desc: string; }, i: number) => (item))
        props.currentForm.setFieldsValue({
            [`environment-general-envprograms-name-${index}`]: '',
            [`environment-general-envprograms-desc-${index}`]: '',
        })
        if (validData.length === 1) {
            setIsValidate(false)
            props.currentForm.validateFields([[`environment-general-envprograms-name-1`]])
        } else {
            const _detailData = JSON.parse(JSON.stringify(detailData))
           // _detailData[index].name = null
           // _detailData[index].desc = null
            _detailData[index] = null

            setDetailData(_detailData)
        }
        props.setValidateCount(props.validateCount + 1)
        // const _detailData  = JSON.parse(JSON.stringify(detailData))
        // _detailData[index].name = null
        // _detailData[index].desc = null
        // setDetailData(_detailData)
    }

    //need add certifaction object and refresh active keys of <Collapse />, which means we need to rerender <Collapse />
    const addEnvironmentalProgram = () => {
        if (!isValidate) {
            setIsValidate(true)
        }
        const newDetails = detailData.concat([{ name: ' ', desc:' '}])
        setDetailData(newDetails)
        setRefreshCount(refreshCount + 1)
        props.setValidateCount(props.validateCount + 1)
    }

    return (
        <>
            <Collapse
                defaultActiveKey={detailData.map((_: object, i : number) => i)}
                multiCollapseButton
                key={refreshCount}
            >
                <>
                    {

                        detailData.map((item: { name: string; desc: string }, i: number) => (
                            <React.Fragment key={i}>
                                {item ?
                                    <Panel
                                        collapsible="header"
                                        header={`Environmental Program ${i + 1}`}
                                        key={i}
                                        className="panel-border"
                                        extra={
                                            <Popconfirm 
                                                placement="leftTop"
                                                title={`Are you sure you want to delete Environmental Programs ${i + 1}?`}
                                                onConfirm={() => deleteItem(i)}
                                                okText="Yes"
                                                cancelText="No">
                                                <CloseCircleOutlined className="panel-btn" />
                                            </Popconfirm>
                                        }
                                    >
                                        <Row gutter={24}>
                                            <Col span={8} key={`col1${i}`}>
                                                <FormItem
                                                    name={`environment-general-envprograms-name-${i}`}
                                                    label="Name"
                                                    rules={[
                                                        { required: isValidate, message: 'This field is required' },
                                                        { max: 64, message: 'You have reached the max character length of 64' }
                                                    ]}>
                                                    <Input maxLength={64} onChange={() => props.setValidateCount((prev : any)=> prev + 1)} />
                                                </FormItem>
                                            </Col>
                                            <Col span={16} key={`col2${i}`}>
                                                <FormItem
                                                    name={`environment-general-envprograms-desc-${i}`}
                                                    label="Description"
                                                    rules={[{ max: 500, message: 'You have reached the max character length of 500' }]}
                                                >
                                                    <TextArea maxLength={500}  autoSize={{ minRows: 1, maxRows: 5 }}/>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Panel> : null}
                            </React.Fragment>
                        ))
                    }
                </>
            </Collapse>
            <Button
                type="link"
                onClick={() => {
                    addEnvironmentalProgram()
                }}
                icon={<PlusOutlined />}
                style={{ display: 'flex', alignItems: 'center', background: '#fff', float: 'right' }}
            >
                {`Add Environmental Program ${detailData.length + 1}`}
            </Button>
        </>
    )
}

export default GeneralEnvironmentalProgramEdit;

